import type { SchemaBuilderFieldTypeNameProps } from "./schema-builder-field-type-name.type";

import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import { getSchemaBuilderFieldType } from "../schema-builder-field-type.helper";

const { Text } = Typography;

export const SchemaBuilderFieldTypeName = ({
  schema,
}: SchemaBuilderFieldTypeNameProps) => {
  const { t } = useTranslation();

  const type = getSchemaBuilderFieldType(schema);

  return (
    <div className="schema-builder-field-type-name">
      <Text>{t(`schema:fieldType.${type}`)}</Text>
    </div>
  );
};
